module.exports = __webpack_public_path__ + "img/08.d92203fe.jpg";